import type { Cursor } from '../../../../api/types';

export interface VisitorCursorManager {
  updateVisitorCursor: (id: string, color: string, cursor: Cursor) => void;
  removeVisitorCursor: (id: string) => void;
  clearVisitorCursors: () => void;
  updateCursorScale: () => void;
}

export function createVisitorCursorManager(area: any): VisitorCursorManager {
  const visitorCursors = new Map<string, HTMLElement>();

  const updateCursorScale = () => {
    const scale = 1 / area.area.transform.k;
    visitorCursors.forEach((el) => {
      el.style.transform = `scale(${scale})`;
    });
  };

  const updateVisitorCursor = (id: string, color: string, cursor: Cursor) => {
    let el = visitorCursors.get(id);
    if (!el) {
      el = document.createElement('div');
      el.className = 'visitor-cursor';
      el.style.position = 'absolute';
      el.style.width = '12px';
      el.style.height = '12px';
      el.style.pointerEvents = 'none';
      el.style.transition = 'left 0.1s ease-out, top 0.1s ease-out';
      el.style.zIndex = '1000';
      el.style.transformOrigin = '0 0';
      el.innerHTML =
        '<svg width="12" height="12" viewBox="0 0 12 12"><path d="M0 0 L0 12 L3 9 L4 12 L5 11 L4 8 L8 8 Z" fill="currentColor"/></svg>';
      area.area.content.add(el);
      visitorCursors.set(id, el);
    }
    el.style.color = color;
    el.style.left = `${cursor.x}px`;
    el.style.top = `${cursor.y}px`;
    el.style.transform = `scale(${1 / area.area.transform.k})`;
  };

  const removeVisitorCursor = (id: string) => {
    const el = visitorCursors.get(id);
    if (el) {
      area.area.content.remove(el);
      visitorCursors.delete(id);
    }
  };

  const clearVisitorCursors = () => {
    visitorCursors.forEach((el) => {
      area.area.content.remove(el);
    });
    visitorCursors.clear();
  };

  return {
    updateVisitorCursor,
    removeVisitorCursor,
    clearVisitorCursors,
    updateCursorScale,
  };
}
